import { useCallback } from 'react';
import { useOpenDeeplink } from '../../../../hooks';
import {
  appendParams,
  finalizeUrl,
  getDefaultWebviewLink,
} from '../../utils';

export const useMoveToReviewList = () => {
  const { openDeeplink } = useOpenDeeplink();

  return useCallback(
    (params: {
      goodsSno: number;
      beautyRecommendOptionsSno?: number;
      titleBar?: boolean;
    }) => {
      const searchParams = new URLSearchParams();

      if (params.beautyRecommendOptionsSno) {
        searchParams.append(
          'beauty_recommend_option_sno',
          `${params.beautyRecommendOptionsSno}`,
        );
      }

      const query = searchParams.toString();
      const path = `/goods/${params.goodsSno}/reviews${query ? `?${query}` : ''}`;

      const link = getDefaultWebviewLink(params.titleBar ?? false);
      appendParams(link, 'url', path);
      openDeeplink(finalizeUrl(link));
    },
    [openDeeplink],
  );
};
